import { User } from '@griply/types';

import { getDeviceTimeZone } from './get-device-time-zone';

// The setting wins over the device — else a fetched event and a synced one can disagree on a day.
export const getUserTimeZone = (user?: User | null): string =>
  user?.settings?.timezone || getDeviceTimeZone() || '';
